import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const OAuthVaultGetRedirectUrl = createAsyncThunk(
    "OAuthVaultGetRedirectUrl",
    async (data, { dispatch }) => {
        try {
            const provider = data?.provider || "microsoft";
            let url = `${API_URL.BASEURL + API_URL?.OAUTH_VAULT_GET_REDIRECT_URL}/${provider}`;
            const params = [];
            if (data?.scopes) {
                params.push(`scopes=${encodeURIComponent(data.scopes)}`);
            }
            if (data?.redirectUri) {
                params.push(`redirectUri=${encodeURIComponent(data.redirectUri)}`);
            }
            if (data?.state) {
                params.push(`state=${encodeURIComponent(data.state)}`);
            }
            if (data?.shop || data?.shopDomain) {
                params.push(`shop=${encodeURIComponent(data.shop || data.shopDomain)}`);
            }
            if (params.length > 0) {
                url += `?${params.join("&")}`;
            }

            let resData = await apiCall(
                {
                    method: "GET",
                    url: url,
                },
                false
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);

export const OAuthVaultExchangeToken = createAsyncThunk(
    "OAuthVaultExchangeToken",
    async (data, { dispatch }) => {
        try {
            const provider = data?.provider || "microsoft";
            let url = `${API_URL.BASEURL + API_URL?.OAUTH_VAULT_TOKEN}/${provider}?currenttoken=${encodeURIComponent(data.encryptedValue)}&passwordvault_displayname=${encodeURIComponent(data.displayname)}&passwordvault_type=${encodeURIComponent(data.type)}`;

            if (data.selectedScopes && data.selectedScopes.length > 0) {
                url += `&selectedScopes=${encodeURIComponent(data.selectedScopes.join(","))}`;
            }
            if (data.redirectUri) {
                url += `&redirectUri=${encodeURIComponent(data.redirectUri)}`;
            }
            if (data.shop || data.shopDomain) {
                url += `&shop=${encodeURIComponent(data.shop || data.shopDomain)}`;
            }
            if (data.passwordvaultid) {
                url += `&passwordvaultid=${encodeURIComponent(data.passwordvaultid)}`;
            }

            let resData = await apiCall(
                {
                    method: "GET",
                    url: url,
                },
                false
            );
            let response = apiResponse(true, resData);
            return response;
        } catch (error) { }
    }
);

const initialState = {
    OAuthRedirectUrlData: {
        data: null,
        error: null,
    },
    OAuthTokenData: {
        data: null,
        error: null,
    },
};

const OAuthVaultSlice = createSlice({
    name: "OAUTH_VAULT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(OAuthVaultGetRedirectUrl.fulfilled, (state, action) => {
                state.OAuthRedirectUrlData.data = action.payload;
            })
            .addCase(OAuthVaultGetRedirectUrl.rejected, (state, action) => {
                state.OAuthRedirectUrlData.error = action.error.message;
            })
            .addCase(OAuthVaultExchangeToken.fulfilled, (state, action) => {
                state.OAuthTokenData.data = action.payload;
            })
            .addCase(OAuthVaultExchangeToken.rejected, (state, action) => {
                state.OAuthTokenData.error = action.error.message;
            });
    },
});

export default OAuthVaultSlice.reducer;
